export const UNHOSTED_PARTNER_CODES = {
  VIN10_UNHOSTED: true,
  VAST_UNHOSTED: true,
};
